
// fix for leaflet css https://github.com/PaulLeCam/react-leaflet/issues/255

import 'leaflet/dist/leaflet.css';

import L from 'leaflet';
import marker from 'leaflet/dist/images/marker-icon.png';
import marker2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
	iconRetinaUrl: marker2x,
	iconUrl: marker,
	shadowUrl: markerShadow
});